var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPassCablecar = function SvgPassCablecar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M16.456 15.5a.53.53 0 0 0 .544-.544v-4.9l-.311-7.234c0-.7-.622-1.322-1.4-1.322h-10.5c-.778 0-1.4.544-1.4 1.322L3 10.056v4.9c0 .31.233.544.544.544z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.75,
    d: "M10 13.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 4H3M17 9.5H3"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15 19-2-2M5 19l2-2"
  })))));
};
export default SvgPassCablecar;